import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { isRewardsCountry } from 'helpers/isRewardsCountry';
import { useUserInfo } from 'hooks/useUserInfo';

const RewardMenu = () => {
  const [button, setButton] = useState('');
  const [featureFlags, setFeatureFlags] = useState({});
  const { user } = useUserInfo();
  const [isRewardsCountryEligible, setIsRewardsCountryEligible] = useState(false);
  useEffect(() => {
    isRewardsCountry(user?.country).then(setIsRewardsCountryEligible);
  }, [user?.country]);

  useEffect(() => {
    getFeatureFlags().then((flags) => {
      setFeatureFlags(flags);
    });
  }, []);

  useEffect(() => {
    if (!button) {
      setButton(window.location.pathname.split('/').slice(-1).pop());
    }
  }, [button]);

  const params = new URLSearchParams(window.location.search);
  let mobile = '';
  if (params.get('mobile')) {
    mobile = '?mobile=true';
  }
  return (
    <div className="rewards-nav">
      <div className="buttons">
        <Link to={`/main/rewards${mobile}`}>
          <button type="button" value="" className={button === 'rewards' ? 'active btn' : 'btn'}>
            <FontAwesomeIcon icon={['fas', 'home']} />
            <span className="button__text">{i18n.translate(featureFlags.ambassador ? 'rewards.menu.homeAmbassador' : 'rewards.menu.home')}</span>
          </button>
        </Link>
        {isRewardsCountryEligible &&
          (featureFlags.badges || featureFlags.metallic_tiers || featureFlags.has_achievements_rewards_page) && (
            <Link to={`/main/rewards/achievements${mobile}`}>
              <button type="button" value="dashboard" className={button === 'achievements' ? 'active btn' : 'btn'}>
                <FontAwesomeIcon icon={['fas', 'bars']} />
                <span className="button__text">{i18n.translate('rewards.menu.achievements')}</span>
              </button>
            </Link>
          )}
        {featureFlags.rewards_booking && isRewardsCountryEligible && (
          <>
            {!featureFlags.is_booking_dashboard_disabled && (
              <Link to={`/main/rewards/dashboard${mobile}`}>
                <button type="button" value="dashboard" className={button === 'dashboard' ? 'active btn' : 'btn'}>
                  <FontAwesomeIcon icon={['far', 'badge']} />
                  <span className="button__text">{i18n.translate('rewards.menu.bookings')}</span>
                </button>
              </Link>
            )}
            <Link to={`/main/rewards/form${mobile}`}>
              <button type="button" value="form" className={button === 'form' ? 'active btn' : 'btn'}>
                <FontAwesomeIcon icon={['fas', 'upload']} />
                {/* {i18n.translate('rewards.menu.form')} */}
                <span className="button__text">{i18n.translate('rewards.menu.form')}</span>
              </button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default RewardMenu;
